import BaseObject from 'app/src/base/BaseObject';
import Backbone from 'backbone';

export default class Navigation extends BaseObject {
  /**
   * An Alternative of navigateToContent() to allow a bypass of the legacy front-end routing and breadcrumbs logic.
   * This will set the Browser history properly to the requested URL.
   *
   * @param {URL} fragment  The URL fragment to navigate to
   */
  static navigateToClientUrl(fragment) {
    /**
     * This is to Bust the Backbone history cache.
     * Which is required to synchronize with how the Legacy webPOS handles browser history.
     */
    Backbone.history.navigate('');
    Backbone.history.navigate(`?client/${fragment}`, { trigger: true, replace: true });
  }

  /**
   * Attempts to trigger a route without updating history or the URL.  Used to sync
   *
   * @param {string} url  The URL fragment to navigate to
   */
  static navigateToRegisterUrl(url) {
    // triggers the route directly if it matches to a route; no mucking with history
    if (/register.php/.test(url)) {
      Backbone.history.loadUrl(url);
    }
  }

  /**
   * Navigate to a legacy WebPOS URL
   *
   * @param {URL} fragment  The URL fragment to navigate to
   */
  static navigateToLegacyUrl(fragment) {
    window.merchantos.utils.openUrl(fragment);
  }

  /**
   * Navigate to a fully-qualified URL
   *
   * @param {URL} url     The URL
   */
  static navigateToUrl(url) {
    window.location.replace(url);
  }

  /**
   * Directs to the webPOS login page which transfers to the specified URL after login.
   *
   * @param {URL} redirectURL    The URL to which the user will be directed after a successful login.
   */
  static loginWithRedirect(redirectURL) {
    window.location.href = `/login.html?redirect_after_login=${encodeURIComponent(redirectURL)}`;
  }

  /**
   * Retrieves the current URL
   *
   * @returns {string}    The current URL fragment
   */
  static currentURL() {
    return window.location.href.replace(/.+?[^\/](\/[^\/])/, '$1');
  }
}
